<template>
  <v-chip :outlined="outlined" :color="color" label
    >{{ etat | etatassociation }} <slot
  /></v-chip>
</template>

<script>
export default {
  props: {
    etat: {
      type: String,
      required: false,
    },
    ignoreStyleRadieeOffice: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    outlined() {
      if (["RECTIFIEE_OFFICE"].includes(this.etat)) {
        return this.ignoreStyleRadieeOffice;
      }
      return true;
    },
    color() {
      if ("DISSOUTE" === this.etat) {
        return "darkgrey";
      } else if ("RADIEE" === this.etat || "RADIEE_OFFICE" === this.etat) {
        return "black";
      } else if ("NONCONFORME" === this.etat) {
        return "error";
      } else if ("RECTIFIEE_OFFICE" === this.etat) {
        return "warning";
      }
      return "primary";
    },
  },
};
</script>
